import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faXmark } from '@fortawesome/pro-solid-svg-icons';
import type { CreateListInputProps } from '../types';

/**
 * Inline input for creating a new list, styled as a selected list item
 */
const CreateListInput: React.FC<CreateListInputProps> = ({
  value,
  onChange,
  onCancel,
}) => {
  return (
    <div
      className="flex items-center gap-3 px-3 py-2 rounded-lg bg-sky-50 border-2 border-sky-500"
      data-testid="create-list-input"
    >
      <FontAwesomeIcon icon={faPlus} className="w-4 h-4 text-sky-600 shrink-0" />
      <input
        type="text"
        placeholder="Enter new list name..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoFocus
        className="flex-1 bg-transparent text-sm text-sky-600 font-semibold placeholder:text-sky-400 placeholder:font-normal focus:outline-none"
        data-testid="new-list-name-input"
        aria-label="New list name"
      />
      <button
        type="button"
        onClick={onCancel}
        className="text-sky-400 hover:text-sky-600 transition-colors cursor-pointer"
        data-testid="cancel-create-list-button"
        aria-label="Cancel new list"
      >
        <FontAwesomeIcon icon={faXmark} className="w-4 h-4" />
      </button>
    </div>
  );
};

export default CreateListInput;
